module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-unknown-5.6c7468e3.svg";